import * as React from "react";

export default () => {
  return <div>Räntespecifik information</div>;
};
